import type { SxProps } from '@mui/material'
import { Box, CircularProgress, Stack } from '@mui/material'
import Paper from '@mui/material/Paper'
import type { ReactNode } from 'react'

type MainContentContainerProps = {
  children: ReactNode
  sx?: SxProps
  isLoading?: boolean
  includeWraper?: boolean
}

function MainContentContainer({ children, sx, isLoading, includeWraper = true }: Readonly<MainContentContainerProps>) {
  if (isLoading) {
    return (
      <Stack
        sx={{
          height: '100%',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          paddingTop: 3,
        }}
      >
        <CircularProgress title="Loading" />
      </Stack>
    )
  }

  if (!includeWraper) {
    return (
      <Box
        sx={{
          my: 2,
          ...sx,
        }}
      >
        {children}
      </Box>
    )
  }

  return (
    <Paper
      sx={{
        my: 2,
        p: 3,
        ...sx,
      }}
    >
      {children}
    </Paper>
  )
}

export default MainContentContainer
